import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrompt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPrompt"><Path d="M6.5 4.5H2.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 4.5H21.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 15.5V19.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 19.5H2.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 9.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 14.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPrompt;
